import { createApp } from "vue";
import OpeningHours from "./OpeningHours.vue";
import { createBootstrap } from "bootstrap-vue-next";

function initializeOpeningHours() {
  if (!/\/faculty-management\/room-building\/\d+\/opening-hours$/.test(window.location.pathname)) {
    return;
  }

  const container = $("#vue-container");
  if (!container.length) {
    console.error("Opening hours container not found");
    return;
  }

  const config = {
    buildingId: parseInt(container.data("buildingId")),
    buildingName: container.data("buildingName"),
    fetchUrl: container.data("fetchUrl"),
    saveUrl: container.data("saveUrl"),
    deleteUrl: container.data("deleteUrl"),
  };

  // Validate required data
  if (!config.buildingId || !config.fetchUrl || !config.saveUrl) {
    console.error("Missing required configuration");
    return;
  }

  createApp(OpeningHours, config).use(createBootstrap()).mount(container[0]);
}

$(initializeOpeningHours);
